import React from 'react';
import DENTToothItem from './DENTToothItem';
import styles from './DENTTooth.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import { ToothView } from '../../Enums/ToothView.enum';
import { Scale } from '../../../Base/Interfaces/Scale.interface';
import DENTToothPeriodontal from '../ToothPeriodontal/DENTToothPeriodontal';
import getPeriodontalPlacement from '../../Helpers/periodontal/getPeriodontalPlacement';
import DENTToothEndodonticIcon from '../DENTToothEndodonticIcon/DENTToothEndodonticIcon';
import { Tooth, ToothState } from '../../../../graphql/graphql';

interface Props {
	data: Tooth;
	views: ToothView[];
	scale: Scale;
	reverse?: boolean;
	isSingleView?: boolean;
	showToothPeriodontal?: boolean;
	showToothNumber?: boolean;
	showToothGrid?: boolean;
	showToothEndodontic?: boolean;
	isDetail?: boolean;
}

const DENTTooth: React.FC<Props> = ({
	data,
	views,
	reverse,
	scale,
	showToothPeriodontal = false,
	showToothNumber = true,
	showToothEndodontic = false,
	isDetail = true,
	showToothGrid = false,
}) => {
	const showToothEndodonticInfo =
		data.state === ToothState.Normal && showToothEndodontic;

	return (
		<div
			className={joinClasses([styles.wrapper, reverse ? styles.reverse : ''])}>
			{showToothEndodonticInfo && (
				<DENTToothEndodonticIcon tooth={data} reverse={reverse} />
			)}
			{showToothPeriodontal && (
				<DENTToothPeriodontal
					periodontal={data.periodontal}
					side={getPeriodontalPlacement(views[0], data.side)}
				/>
			)}
			<div className={styles.teeth}>
				{views.map((view, index) => (
					<DENTToothItem
						data={data}
						view={view}
						key={index}
						scale={scale}
						isDetail={isDetail}
						showToothGrid={showToothGrid ? view !== ToothView.INCISAL : false}
					/>
				))}
			</div>
			{showToothPeriodontal && (
				<DENTToothPeriodontal
					periodontal={data.periodontal}
					side={getPeriodontalPlacement(views[views.length - 1], data.side)}
				/>
			)}
			{showToothNumber && <div className={styles.number}>{data.number}</div>}
		</div>
	);
};

export default DENTTooth;
